var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumenttext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4334 2.57841C17.955 2.10007 17.1267 2.42674 17.1267 3.09174V7.16341C17.1267 8.86674 18.5734 10.2784 20.335 10.2784C21.4434 10.2901 22.9834 10.2901 24.3017 10.2901C24.9667 10.2901 25.3167 9.50841 24.85 9.04174C23.17 7.35007 20.16 4.30507 18.4334 2.57841Z",
    fill: "#38369C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9166 11.8885H20.545C17.78 11.8885 15.5283 9.63683 15.5283 6.87183V3.50016C15.5283 2.8585 15.0033 2.3335 14.3616 2.3335H9.41496C5.82163 2.3335 2.91663 4.66683 2.91663 8.83183V19.1685C2.91663 23.3335 5.82163 25.6668 9.41496 25.6668H18.585C22.1783 25.6668 25.0833 23.3335 25.0833 19.1685V13.0552C25.0833 12.4135 24.5583 11.8885 23.9166 11.8885ZM13.4166 20.7085H8.74996C8.27163 20.7085 7.87496 20.3118 7.87496 19.8335C7.87496 19.3552 8.27163 18.9585 8.74996 18.9585H13.4166C13.895 18.9585 14.2916 19.3552 14.2916 19.8335C14.2916 20.3118 13.895 20.7085 13.4166 20.7085ZM15.75 16.0418H8.74996C8.27163 16.0418 7.87496 15.6452 7.87496 15.1668C7.87496 14.6885 8.27163 14.2918 8.74996 14.2918H15.75C16.2283 14.2918 16.625 14.6885 16.625 15.1668C16.625 15.6452 16.2283 16.0418 15.75 16.0418Z",
    fill: "#38369C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumenttext);
export default __webpack_public_path__ + "static/media/documenttext.65246296348eaad5f58b61f47ac16a97.svg";
export { ForwardRef as ReactComponent };